<div class="summary-card"
     [class.summary-card--compact]="compact"
     [class.summary-card--interactive]="interactive">
  <a #link [routerLink]="(airport.sourceId === 10 || airport.sourceId === 12) ?
     ['/airports', airport.identifier, 'island'] : ['/airports', airport.identifier]" class="summary-card__wrapper"
     [class.summary-card__wrapper--active]="active"
     (mouseover)="onHover(true)" (mouseleave)="onHover(false)">
    <div class="summary-card__header">
      <div class="summary-card__name-review">
        <h2 class="summary-card__header-text">
          {{ identifier }} {{ airport.name }}
          <app-airport-icons class="summary-card__icons" [airport]="airport" [compact]="true"></app-airport-icons>
        </h2>
        <app-review-overview *ngIf="airport.reviewSummary" [reviewSummary]="airport.reviewSummary"></app-review-overview>
      </div>
      <div class="summary-card__header-actions">
        <app-airport-home-icon [identifier]="airport.identifier" [faaid]="airport.faaId"></app-airport-home-icon>
        <app-airport-favorite-icon [identifier]="airport.identifier"></app-airport-favorite-icon>
      </div>
    </div>
    <div class="summary-card__body">
      <div class="summary-card__field">
        <div class="summary-card__field-value">
          <ng-container *ngIf="airport.maxRunwayLength; else na">{{ airport.maxRunwayLength | number }} ft</ng-container>
        </div>
        <div class="summary-card__field-label">Max Runway</div>
      </div>
      <div class="summary-card__field">
        <div class="summary-card__field-value">{{ airport.towered | boolean }}</div>
        <div class="summary-card__field-label">Towered</div>
      </div>
      <div class="summary-card__field">
        <div class="summary-card__field-value">
          <ng-container *ngIf="minFuel; else na">{{ minFuel | currency: 'USD' : 'symbol-narrow' : '1.2' }}</ng-container>
        </div>
        <div class="summary-card__field-label">Fuel ({{ fuelTypeStr }})</div>
      </div>
    </div>
  </a>
</div>

<ng-template #na>
  <span class="na">--</span>
</ng-template>
